export default __webpack_public_path__ + "images/fd6af2af105f401ddb256fcefb1a9f35-social_media_small.webp";